module.exports = __webpack_public_path__ + "img/bfxs.09ab907b.png";